import React, { useState, useContext, useEffect } from "react";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useGroupScreen } from "./hooks/useGroupScreen";
import FInputt from "../../components/FInputt/FInputt";
import { useFormat } from "../../hooks/useFormat";
import { useGroup } from "../../hooks/useGroups";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useShareFiado } from "../../hooks/useShareFiado";
import { getIdenticator } from "../../api/directory";
import { useFormik } from "formik";
import { type } from "@testing-library/user-event/dist/type";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { usePhoneFormat } from "../../hooks/usePhoneFormat";
import { useContacts } from "../../hooks/useContacts";
import { size } from "lodash";
import Swal from "sweetalert2";
import FcardContact from "../../components/FcardContact/FcardContact";


const AddPerson = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation();
  const { validateLocalPhone } = usePhoneFormat();

  const [identityInfo, setIdentityInfo] = useState([]);
  const [isRegistered, setIsRegistered] = useState(false);
  const [idempotencyKey, setIdempotencyKey] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [newContacts, setNewContacts] = useState([]);

  const { setLoading, checkToken } = useContext(AuthContext);
  const { getFirstDigits } = useShareFiado();
  const idNewContacts = newContacts.map((member) => member?.directoryId);
  const namesNewContacts = newContacts.map((member) => member?.name);
  const {
    getFavoriteContacts,
    favoriteContacts,
    getFirstLetter,
    aleatory3colors,
    getTwoWords,
  } = useContacts();

  const getIdentify = async (number) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getIdenticator(number);
      if (
        state.members.includes(data.data.directoryId) ||
        idNewContacts.includes(data.data.directoryId)
      ) {
        formikAdd.setFieldValue("phoneNumber", "");
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: `${data.data.name} ya se encuentra en tu Grupo`,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      } else {
        //console.log(data.data.directoryId)
        formikAdd.setFieldValue("phoneNumber", "");

        setIdentityInfo(data.data);
        setIsRegistered(true);
        setNewContacts([...newContacts, data.data]);
      }
      setLoading(false);
      return true;
    } catch (error) {
      setLoading(false);
      console.log(error);
      return false;
    }
  };

  const identify = async (number) => {
    const response = await getIdentify(number);
    if (response === false) {
      formikAdd.setFieldValue("phoneNumber", "");
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Esta persona no se encuentra registrada en Fiado",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };

  const getIdentifyByNumber = (number) => {
    if (typeof number == "string") {
      if (getFirstDigits(number) === "+1" && number.length === 12) {
        identify(number);
      } else if (
        (getFirstDigits(number) === "+52" || "+57") &&
        number.length === 13
      ) {
        identify(number);
      }
    }
  };

  const list = idNewContacts.map((member) => ({ directoryId: member }));

  const { addMember } = useGroup();

  const nextScreen = async (groupId, members) => {
    const resp = await addMember(groupId, members);
    if (resp == true) {
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: "Se agregaron los contactos a tu grupo",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        }
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo agregar los contactos a tu grupo",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        }
      })
    }
  };

  const formikAdd = useFormik({
    initialValues: {
      phoneNumber: "",
      directoryId: "",
    },
    onSubmit: async () => {
      console.log(newContacts);
      state.type == "create"
        ? route("/CreateGroupScreen", {
            state: {
              newContacts: newContacts,
              members: list,
              nameList: namesNewContacts,
            },
          })
        : nextScreen(state.groupId, list);
    },
    validate: (values) => {
      const errors = {};

      if (!(newContacts.length > 0)) {
        if (!values.phoneNumber) {
          errors.phoneNumber = "Número de teléfono requerido";
        } else {
          if (!validateLocalPhone(values.phoneNumber))
            errors.phoneNumber = "Ingrese un teléfono de celular válido";
        }
      }

      return errors;
    },
  });

  useEffect(() => {
    formikAdd.setFieldValue("directoryId", "");
    console.log(formikAdd?.values.phoneNumber);
    getIdentifyByNumber(formikAdd?.values?.phoneNumber);
  }, [formikAdd?.values?.phoneNumber]);

  useEffect(() => {
    console.log(newContacts);
  }, [newContacts]);

  const [aleatory3colorss, setaleatory3colorss] = useState("");

  useEffect(() => {
    setaleatory3colorss(aleatory3colors());

    getFavoriteContacts();
  }, []);

  const { codeCountryToOnlyCountry } = useFormat();
  const [codeCountryInit, setCodeCountryInit] = useState("mx");

  return (
    <>
      <FContainer>
        <div className="border-0 w-full text-center font-bold text-[4vw] smm:text-[18px] xxs:text-[14px]">
          Ingresa el número de la persona a quien quieres agregar
        </div>

        <FInputText
          type="PhoneInput"
          value={formikAdd.values.phoneNumber}
          codeCountryInit={codeCountryInit}
          onChange={(value) => {
            setPhoneNumber(value);
            formikAdd.setFieldValue("phoneNumber", value);
            setCodeCountryInit(codeCountryToOnlyCountry(value))
          }}
          errorMessage={formikAdd.values.phoneNumber == "" ? "": formikAdd.errors.phoneNumber}
        />
          
        {newContacts.length > 0
          ? newContacts.map((contact, index) => (
            <FcardContact
            backgroundInitial={aleatory3colorss}
            className="!shadow-none !my-2"
                preferredName={contact.name}
                onDeleteMembers={() => {
                  setNewContacts(
                    newContacts.filter(
                      (item) => item.directoryId != contact.directoryId
                    )
                  );
                }}
              />
            ))
          : null}

        {(favoriteContacts?.length > 0) ?
        <div>
          <div className="border-0 w-full text-center font-bold text-[4vw] smm:text-[18px] xxs:text-[14px] py-5">
            Contactos frecuentes
          </div>
          <div className="mt-5 flex content-center  items-center  bg-stripes-sky text-center h-28 p-1 justify-start  overflow-y-hidden overflow-x-scroll">
          {favoriteContacts.map((contact, index) => (
                <div
                  className="p-2 grid place-items-center"
                  onClick={() => {
                    setPhoneNumber(contact.phoneNumber);
                    setCodeCountryInit(codeCountryToOnlyCountry(contact.phoneNumber))
                    formikAdd.setFieldValue("phoneNumber", contact.phoneNumber);
                  }}
                >
                  <div>
                    <div
                      style={{ backgroundColor: aleatory3colorss }}
                      className={`shadow-lg rounded-[12px] h-[60px] w-[60px] font-bold flex flex-col justify-center cursor-pointer`}
                    >
                      <div className="text-white text-xl">
                        {getFirstLetter(contact.preferedName)}
                      </div>
                    </div>
                  </div>
                  <div>{getTwoWords(contact.preferedName)}</div>
                </div>
              ))
          }
        </div>
        </div>
         : null
        }
        
        <Fbutton
          value="Continuar"
          // disabled={!formikAdd.isValid}
          disabled={!(newContacts.length > 0)}
          onClick={formikAdd.handleSubmit}
        />
      </FContainer>
    </>
  );
};

export default AddPerson;
